import { UserManager } from "oidc-client-ts";

import { env } from "@/config/env";

type SignInState = {
    returnTo: string;
};

export const authCallbackPath = "/auth/callback";

const userManager = new UserManager({
    authority: env.cognito.authority,
    client_id: env.cognito.clientId,
    redirect_uri: `${window.location.origin}${authCallbackPath}`,
});

export const getAccessToken = async () => {
    const user = await userManager.getUser();
    if (!user || user.expired) {
        return null;
    }
    return user.access_token;
};

export const isSignedIn = async () => (await getAccessToken()) !== null;

export const signIn = (returnTo: string) => {
    const state: SignInState = { returnTo };
    return userManager.signinRedirect({ state });
};

export const completeSignIn = async () => {
    const user = await userManager.signinRedirectCallback();
    const state = user.state as SignInState | undefined;
    if (!state) {
        return "/";
    }
    return state.returnTo;
};

export const signOut = () =>
    userManager.signoutRedirect({
        extraQueryParams: { client_id: env.cognito.clientId, logout_uri: window.location.origin },
    });
